"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MapSideBarNavigationItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapSideBarNavigationItem.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let MapSideBarNavigation = class MapSideBarNavigation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get hasProjects() {
        const params = new URLSearchParams(window.location.search);
        const projectId = params.get('projectId');
        const areaId = params.get('areaId');
        return projectId && areaId ? true : false;
    }
    //activePanel = 'home'
    get panels() {
        const commonPanels = [
            // {
            //     hook: 'back',
            //     label: 'Back',
            //     icon: 'ArrowLeftIcon',
            // },
            {
                hook: 'home',
                label: 'Home',
                icon: 'HomeIcon',
                isVisible: true
            },
            {
                hook: 'projects',
                label: 'Projects',
                icon: 'ListIcon',
                isVisible: true
            },
            {
                hook: 'farms',
                label: 'Farms List',
                icon: 'PhChIcon',
                isVisible: true
            },
            {
                hook: 'metrics',
                label: 'Metrics',
                icon: 'Chart2Icon',
                isVisible: true
            }, {
                hook: 'products',
                label: 'Products',
                icon: 'Sprout',
                isVisible: true
            }
            /*             {
                            hook: 'toolbox',
                            label: 'Toolbox',
                            icon: 'ToolboxIcon',
                        },
                        {
                            hook: 'actions',
                            label: 'Actions',
                            icon: 'SuiteIcon',
                        }, */
        ];
        // Antes estaba el flag this.enableNeedMaps
        /*         if (this.enableNeedMaps) {
                    commonPanels.splice(commonPanels.length - 1, 0, {
                        hook: 'need-maps',
                        label: 'Needs Maps',
                        icon: 'RecommendationIcon',
                        isVisible: this.hasProjects})
                } */
        commonPanels.splice(commonPanels.length - 1, 0, {
            hook: 'need-maps',
            label: 'Needs Maps',
            icon: 'RecommendationIcon',
            isVisible: true
        });
        // commonPanels.splice(commonPanels.length - 1, 0, {
        //     hook: 'recommendations',
        //     label: 'Recommendations',
        //     icon: 'RecommendationIcon'})
        //
        // commonPanels.splice(commonPanels.length, 0, {
        //     hook: 'agronomicInsights',
        //     label: 'Agronomic Insights',
        //     icon: 'GuideIcon',
        // });
        return commonPanels;
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    changePanel(panel) {
        this.$emit('changePanel', panel);
        this.eventTrackerListener(`open${this.capitalizeFirstLetter(panel)}Panel`, { panel: panel });
        if (panel.toLowerCase() === 'home') {
            this.eventTrackerListener(`BackHome`, true);
        }
    }
    ;
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'horizontal' })
], MapSideBarNavigation.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'home' })
], MapSideBarNavigation.prototype, "activePanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarNavigation.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarNavigation.prototype, "isBmk", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarNavigation.prototype, "enableNeedMaps", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarNavigation.prototype, "theme", void 0);
MapSideBarNavigation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarNavigationItem: MapSideBarNavigationItem_vue_1.default,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            ListIcon: bmk_ui_framework_1.ListIcon,
            ToolboxIcon: bmk_ui_framework_1.ToolboxIcon,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
            Chart2Icon: bmk_ui_framework_1.Chart2Icon,
            SuiteIcon: bmk_ui_framework_1.SuiteIcon,
            RecommendationIcon: bmk_ui_framework_1.RecommendationIcon,
            GuideIcon: bmk_ui_framework_1.GuideIcon,
            PhChIcon: bmk_ui_framework_1.PhChIcon,
            Lightbulb: lucide_vue_next_1.Lightbulb
        },
    })
], MapSideBarNavigation);
exports.default = MapSideBarNavigation;
